import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {PAGES_AND_PATHS} from '../../../constants/pages-and-paths';
import {SingleListPublicComponent} from './single-list-public.component';
import {PublicListGuardService} from '../../../guards/public-list-guard.guard';

const routes: Routes = [
  {
    path: PAGES_AND_PATHS.singleListPublic.pageInRouting,
    data: { data: PAGES_AND_PATHS.singleListPublic },
    component: SingleListPublicComponent,
    canActivate: [PublicListGuardService],
    loadChildren: () => import('./single-list-public.module').then(m => m.SingleListPublicModule)
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SingleListPublicRoutingModule { }
